export const ACCESS_TOKEN_KEY = 'zhiht_order_admin_access_token';
export const REFRESH_TOKEN_KEY = 'zhiht_order_admin_refresh_token';
export const TOKEN_EXPIRES_AT_KEY = 'zhiht_order_admin_expires_at';
export const TEMP_TOKEN_KEY = 'zhiht_order_admin_temp_token';
export const USER_CONTEXT_KEY = 'zhiht_order_admin_user_context';

export const SUCCESS_CODE = 20000;
export const NO_PERMISSION_CODE = 30000;
export const REFRESH_REQUIRED_CODE = 40000;
export const LOGIN_EXPIRED_CODES = [50001, 50002, 50003];

export const REQUEST_TIMEOUT = 10_000;
export const LOGIN_PATH = '/user/login';
export const SELECT_CONTEXT_PATH = '/user/select-company-shop';
export const REDIRECT_QUERY_KEY = 'redirect';
export const SESSION_EXPIRED_MESSAGE = '登录状态已过期，请重新登录';
export const LOGIN_MODE_DIRECT = 'direct';
export const LOGIN_MODE_SELECT_CONTEXT = 'select_context';
